import { render, staticRenderFns } from "./NewForm.vue?vue&type=template&id=ad8b01de&"
import script from "./NewForm.vue?vue&type=script&lang=js&"
export * from "./NewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports